import numberWithCommas from '../../../utils/numberWithCommas';
import { Col } from '../../Grid';

const RenderLinkpoints = ({ availableLpBalance, accesstoken }) => (
  <Col className="exchange-points">
    <img src="../../static/img/pages/exchange/linkpoints.png?v=1" alt="linkpointsLogo" />
    <h4>
      Linkpoints ({numberWithCommas(Number(availableLpBalance).toFixed(2))})
      <div className="exchange-member-id">Member ID: {accesstoken}</div>
    </h4>
  </Col>
);

export default RenderLinkpoints;
